module.exports = __webpack_public_path__ + "img/[惊恐].31d7c70e.svg";